import { useEffect } from "react";
import { useSelector } from "react-redux";

import ReportDashboardSection from "../../components/Reports/ReportDashboardSection";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import Page from "../../finwell/pages/Page";
const ReportDashboard = () => {
  const userRole = useSelector((state) => state.user.role);
  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  return (
    <>
      {!localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ||
      userRole === "manager" ? (
     <Page>
          <ReportDashboardSection isMobile={false} hideSaveFilter={"0"} />
       </Page>
      ) : (
        <div className="container mt-3">
          <strong>Unauthorized Access.</strong>
        </div>
      )}
      
    </>
  );
};

export default ReportDashboard;
